<template>
  <div style="padding-top: 35px" v-loading="loadingPridobivanjeTelefonskihStevilk">
    <div>
      <p class="navadno-besedilo">
        Želite popolnoma obvladovati stroške telekomunikacij?
        <br/>
        Izberite zakup dodatnih enot, ki jih lahko uporabljate na vseh stacionarnih ali mobilnih številkah v okviru
        posameznega naročniškega razmerja.
      </p>
    </div>
    <div style="padding-top: 10px">
      <p class="navadno-besedilo">
        Ena enota predstavlja
        <b>1 minuto pogovora</b>
        ali
        <b>
          MMS/SMS sporočilo
        </b>
        v vsa slovenska telekomunikacijska omrežja, ali
        <b>
          1 MB
        </b>
        prenesenega mobilnega podatkovnega prometa.
        <br/>
        Enote, ki ste jih zakupili za posamezno številko, lahko porabljate na vseh številkah v
        okviru naročniškega razmerja.
      </p>
    </div>
    <div>
      <div style="padding-top: 20px">
        <div v-if="seznamTelStevilk.length > 0">
          <div>
            <el-form label-width="120px" :label-position="formaOrientacija">
              <el-form-item label="Izbira številke">
                <el-select class="velikost-izbirnia-telefonskih izbirnik-long mobile" v-model="izbranaTelefonska"
                           placeholder="Izberite tel. številko" @change="Nastavitevprikljucka">
                  <el-option v-for="(data, key) in seznamTelStevilk" :value="data.telefonska_stevilka"
                             :label="VrniFormatiranoTelefonsko(data.telefonska_stevilka, data.tip_stevilke)"
                             :key="key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-else>
          <p>
            <b>
              Za naročilo trenutno ni na voljo telefonskih številk.
            </b>
          </p>
        </div>
      </div>
      <div class="postavitev-paketi-televizija" v-if="seznamEnot.length > 0"
           v-loading="pridobivanjeNarocenihVklopljenihPodatkov">
        <div v-for="posamezenaEnota in seznamEnot">
          <div class="postavitev-paketov-enote">
            <div class="open-sans-20pt">
              <b>
                {{ posamezenaEnota.naziv.toUpperCase() }}
              </b>
            </div>
            <div class="podcrtan-naziv-enote"/>
            <br/>
            <el-col class="izpis-opisa-enote"> {{ posamezenaEnota.opis }}
            </el-col>
            <div class="izpis-cena-enote">
              {{ posamezenaEnota.cena }} € / mesec
            </div>
            <div>
              <div>
                <OrderButton
                  v-if="posamezenaEnota.vklopljeno === 0 && posamezenaEnota.naroceno === 0 || posamezenaEnota.vklopljeno === 1 && posamezenaEnota.naroceno === 1"
                  :services="[{serviceId: posamezenaEnota.idStoritevVrstaIzbira, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucekTelefonskeSt)}]"
                  class="postavitev-gumb-narocanje"
                  :service-name="posamezenaEnota.naziv.toLowerCase()"
                  style="width: 95px"
                  @orderConfirmed="SetNarociNovPaket()"
                >
                  NAROČI
                </OrderButton>
                <OrderButton
                  :disabled="posamezenaEnota.vklopljeno === 0 && posamezenaEnota.naroceno === 1"
                  v-if="(posamezenaEnota.vklopljeno === 1 && posamezenaEnota.naroceno === 0) || (posamezenaEnota.vklopljeno === 0 && posamezenaEnota.naroceno === 1)"
                  :services="[{serviceId: posamezenaEnota.idStoritevVrstaIzbira, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucekTelefonskeSt)}]"
                  class="postavitev-gumb-narocanje"
                  :service-name="posamezenaEnota.naziv.toLowerCase()"
                  style="width: 95px;"
                  @orderConfirmed="SetNarociNovPaket()"
                >
                  {{posamezenaEnota.vklopljeno === 0 && posamezenaEnota.naroceno === 1 ? 'NAROČILO V TEKU' : 'ODJAVI'}}
                </OrderButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OrderExistsInfo v-if="hasAnyPendingOrder"/>
    </div>
  </div>
</template>

<script>
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import {StringConverter} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import {
  Button,
  Form,
  FormItem,
  Input,
  Option,
  Select,
  Col
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent'
import {StoritevVrstaEnum} from '../../../../../assets/js/Enum/StoritevVrstaEnum'
import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
import Vue from 'vue'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'

export default {
  name: 'Enote',
  mixins: [PrikazVsebine,
    StringConverter,
    PridobivanjeVklopljenoNaroceno,
    StoritevVrstaEnum,
    FormatirajTelefonskoStevilko
  ],
  data () {
    return {
      formaOrientacija: 'left',
      mejnaSirina: 800,
      seznamTelStevilk: [],
      seznamVklopljenih: [],
      seznamNarocenih: [],
      izbranaTelefonska: '',
      seznamEnot: [],
      izbranPrikljucekTelefonskeSt: '',
      loadingPridobivanjeTelefonskihStevilk: true,
      pridobivanjeNarocenihVklopljenihPodatkov: true,
      orderExists: false
    }
  },
  components: {
    OrderButton,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Col.name]: Col,
    OrderExistsInfo
  },
  props: {
    izbranaSap: ''
  },
  watch: {
    izbranaSap: function () {
      if (this.izbranaSap !== null) {
        this.GetTelefonske()
      }
    },
    izbranaTelefonska: function () {
      if (this.izbranaTelefonska !== null) {
        this.GetNaborStoritevEnote()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetTelefonske()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    getTelefonskeAdmin () {
      if (this.izbranaSap !== '' && this.izbranaSap !== null) {
        let request = {
          permissionId: 'ADMIN_PORABA_TELEFONIJA',
          filter: {
            'sap': this.izbranaSap
          }
        }
        return this.clientAgent.makeRequest(
          'permissions/havePermission',
          request,
          'POST'
        )
      }
    },
    async GetTelefonske () {
      if (this.izbranaSap !== '' && this.izbranaSap !== null) {
        this.nalaganjeTelefonskihStevilk = true
        let request = {
          permissionId: 'PORABA_TELEFONIJA',
          filter: {
            'sap': this.izbranaSap
          }
        }
        let response = await this.clientAgent.makeRequest(
          'permissions/havePermission',
          request,
          'POST'
        )
        if (response.permission.additionalData === null || response.permission.additionalData.length === 0) {
          response = await this.getTelefonskeAdmin()
        }
        this.SetTelefonske(response)
      }
    },
    SetTelefonske (podatki) {
      this.seznamTelStevilk = []
      this.izbranaTelefonska = ''
      this.izbranPrikljucekTelefonskeSt = ''
      if (podatki.permission.additionalData !== null && podatki.permission.additionalData.length > 0) {
        for (let i = 0; i < podatki.permission.additionalData.length; i++) {
          this.seznamTelStevilk.push(podatki.permission.additionalData[i])
        }
        this.izbranaTelefonska = podatki.permission.additionalData[0].telefonska_stevilka
        this.izbranPrikljucekTelefonskeSt = podatki.permission.additionalData[0].id_prikljucek
      } else {
        this.getTelefonskeAdmin()
      }
      this.loadingPridobivanjeTelefonskihStevilk = false
    },
    ErrTelefonske (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.loadingPridobivanjeTelefonskihStevilk = false
    },
    Nastavitevprikljucka () {
      for (let i = 0; i < this.seznamTelStevilk.length; i++) {
        if (this.izbranaTelefonska === this.seznamTelStevilk[i].telefonska_stevilka) {
          this.izbranPrikljucekTelefonskeSt = ''
          this.izbranPrikljucekTelefonskeSt = this.seznamTelStevilk[i].id_prikljucek
        }
      }
      this.pridobivanjeNarocenihVklopljenihPodatkov = true
    },
    GetNaborStoritevEnote () {
      if (this.izbranPrikljucekTelefonskeSt !== '' && this.izbranaTelefonska !== '') {
        let param = ['idPrikljucek=' + this.izbranPrikljucekTelefonskeSt]
        param.push('stevilka=' + this.izbranaTelefonska)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/enote/naborStoritev?',
          param,
          null,
          'SetNaborStoritevEnote',
          'ErrNaborStoritevEnote')
      }
    },
    SetNaborStoritevEnote (podatki) {
      this.seznamEnot = []
      this.seznamEnot = podatki.data.storitve
      for (let i = 0; i < this.seznamEnot.length; i++) {
        Vue.set(this.seznamEnot[i], 'vklopljeno', 0)
        Vue.set(this.seznamEnot[i], 'naroceno', 0)
      }
      this.VklopljeneNaroceneEnote()
    },
    VklopljeneNaroceneEnote () {
      this.seznamVklopljenih = []
      this.seznamNarocenih = []
      let param = {}
      param.vmesnik = this
      param.prenesenIzbranId = this.izbranPrikljucekTelefonskeSt
      param.idVrsta = [StoritevVrstaEnum.ENOTE]
      param.idStatusNaroceno = 0
      param.idStatusVklopljeno = 1
      this.GetVklopljeneStoritve(param)
      this.GetNaroceneStoritve(param)
    },
    SetNarociNovPaket () {
      this.Nastavitevprikljucka()
      this.GetNaborStoritevEnote()
    },
    ErrNarociNovPaket (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SetSeznamVkloplenihStoritev (prenParametri, seznamVklopljenih) {
      this.seznamVklopljenih = []
      this.seznamVklopljenih = seznamVklopljenih
      if (this.seznamVklopljenih !== 0) {
        for (let i = 0; i < this.seznamVklopljenih.length; i++) {
          if (typeof this.seznamEnot !== 'undefined') {
            for (let j = 0; j < this.seznamEnot.length; j++) {
              if (this.seznamEnot[j].idStoritevVrstaIzbira === this.seznamVklopljenih[i].idStoritev) {
                Vue.set(this.seznamEnot[j], 'vklopljeno', 1)
              }
            }
          }
        }
      }
      this.pridobivanjeNarocenihVklopljenihPodatkov = false
    },
    SetSeznamNarocenihStoritev (prenParametri, seznamNarocenih) {
      this.seznamNarocenih = []
      this.seznamNarocenih = seznamNarocenih
      if (this.seznamNarocenih !== 0) {
        for (let i = 0; i < this.seznamNarocenih.length; i++) {
          if (typeof this.seznamEnot !== 'undefined') {
            for (let j = 0; j < this.seznamEnot.length; j++) {
              if (this.seznamEnot[j].idStoritevVrstaIzbira === this.seznamNarocenih[i].idStoritev) {
                Vue.set(this.seznamEnot[j], 'naroceno', 1)
              }
            }
          }
        }
      }
      this.pridobivanjeNarocenihVklopljenihPodatkov = false
    }
  },
  computed: {
    hasAnyPendingOrder () {
      let out = false
      if (Array.isArray(this.seznamEnot)) {
        this.seznamEnot.forEach((item) => {
          if (item.naroceno === 1) {
            out = true
          }
        })
      }
      return out
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Naroci/NarociTelefonija/Enote.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelefonija/Enote.vue